var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import KnockoutModel from "../../lib/knockout_model";
import '../../components/tag-input';
var TagModel = /** @class */ (function (_super) {
    __extends(TagModel, _super);
    function TagModel(root) {
        var _this = _super.call(this, "", root, {}) || this;
        _this.tags = ko.observableArray();
        return _this;
        ///  this.tags.subscribe(n => console.log(n))
    }
    return TagModel;
}(KnockoutModel));
var headerModel = /** @class */ (function (_super) {
    __extends(headerModel, _super);
    function headerModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    headerModel.prototype.init = function () {
        new TagModel(this.container).bind();
    };
    return headerModel;
}(Page));
export default headerModel;
